import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {BaseComponent, CrmIssue, IdAndHeader, IssueEnvironment} from "compob2b-libs";
import {map, takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-issue-environment',
    templateUrl: 'issue-environment.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IssueEnvironmentComponent extends BaseComponent implements OnInit {
  @Input() issue: CrmIssue;
  @Output() changeEnvironment: EventEmitter<IssueEnvironment[]> = new EventEmitter();
  public items: IdAndHeader[] = [];

  ngOnInit(): void {
    this.loadItems();
  }

  private loadItems() {
    if (!this.items.length) {
      this.compoApiService.get<any[]>('/issue/list-environments')
        .pipe(
          map(response => response.data),
          takeUntil(this.unsubscribe)
        )
        .subscribe(items => this.items = items);
    }
  }

  changeSelected(items: IssueEnvironment[]) {
    this.changeEnvironment.emit(items);
  }

  compareEntities(a: IdAndHeader, b: IdAndHeader) {
    return a.id === b.id;
  }
}
